import { gql, useQuery } from '@apollo/client'
import { useEffect, useMemo } from 'react'

import {
  ItemResaleRaffleUserDetailFragmentDoc,
  ResaleApplicationCreateCompletionQuery,
  ResaleApplicationCreateCompletionQueryVariables,
} from '@/clients/utoniq-core/schema'
import { useRouter } from '@/core'
import { makeViewModel } from '@/core/architecture'
import { removeResaleApplicationInput } from '@/core/native/storage'
import { decodeSkuId, setItemSku } from '@/core/sku'
import { nextRaffleDateTime } from '@/lib/dayjs'

import { Action, State } from './template'

/**
 *
 */
export const useViewModel = makeViewModel<State, Action>(() => {
  const { router } =
    useRouter<{ itemId: string; raffleId: string; skuId?: string }>()

  const { data, loading } = useQuery<
    ResaleApplicationCreateCompletionQuery,
    ResaleApplicationCreateCompletionQueryVariables
  >(QUERY, {
    variables: {
      raffleId: router.query.raffleId,
      itemId: router.query.itemId,
      skuId: decodeSkuId(router.query?.skuId ?? '') || undefined,
    },
  })

  const itemResaleRaffleUser = useMemo(() => {
    if (!data?.itemResaleRaffleUser) {
      return null
    }
    return {
      ...data.itemResaleRaffleUser,
      item: setItemSku(data.itemResaleRaffleUser.item, router.query?.skuId),
    }
  }, [data?.itemResaleRaffleUser, router.query?.skuId])

  useEffect(() => {
    return () => {
      removeResaleApplicationInput()
    }
  }, [])

  return {
    state: {
      loading,
      itemResaleRaffleUser,
      raffledAtNext: nextRaffleDateTime(),
    },
    actions: {},
  }
})

const QUERY = gql`
  query ResaleApplicationCreateCompletion(
    $raffleId: ID!
    $itemId: String!
    $skuId: String
  ) {
    itemResaleRaffleUser(raffleId: $raffleId, itemId: $itemId) {
      ...ItemResaleRaffleUserDetail
    }
  }
  ${ItemResaleRaffleUserDetailFragmentDoc}
`
